import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// Рамка предпросмотра: поверх админки показывает, как заполненное
// увидит клиент, и внизу/сверху даёт подтвердить или вернуться к правкам.
//
// Языки переключаются прямо здесь — сайт многоязычный, и удобно сразу
// проверить, что заполнены все три версии. При закрытии язык админки
// возвращается к тому, что был.
const LANGS = [
  { code: "ru", label: "Рус" },
  { code: "en", label: "Eng" },
  { code: "kk", label: "Қаз" },
];

export default function PreviewOverlay({
  title = "Так это увидит клиент",
  confirmLabel = "Всё верно — сохранить",
  onBack,
  onConfirm,
  saving = false,
  children,
}) {
  const { i18n } = useTranslation();
  const [lang, setLang] = useState(i18n.language);

  useEffect(() => {
    const original = i18n.language;
    return () => {
      // вернуть язык админки как было
      i18n.changeLanguage(original);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const switchLang = (code) => {
    setLang(code);
    i18n.changeLanguage(code);
  };

  // страница под оверлеем не должна прокручиваться вместе с ним
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  return (
    <div className="fixed inset-0 z-[80] overflow-y-auto bg-kj-dark text-kj-ink">
      <div className="sticky top-0 z-10 border-b border-white/10 bg-neutral-900/95 backdrop-blur">
        <div className="max-w-[1526px] mx-auto px-4 py-3 flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-4">
            <span className="text-sm font-bold uppercase tracking-[0.12em] text-kj-gold">
              {title}
            </span>
            <div className="flex items-center gap-1">
              {LANGS.map((l) => (
                <button
                  key={l.code}
                  type="button"
                  onClick={() => switchLang(l.code)}
                  className={`px-2.5 py-1 rounded text-xs font-bold uppercase tracking-[0.08em] transition-colors ${
                    lang === l.code
                      ? "bg-kj-gold text-neutral-900"
                      : "text-neutral-300 hover:text-white"
                  }`}
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>

          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={onBack}
              className="px-4 py-2 rounded-md border border-neutral-500 text-sm font-medium text-neutral-100 hover:bg-white/10"
            >
              Вернуться к правкам
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={saving}
              className="px-4 py-2 rounded-md text-sm font-medium text-white bg-sky-600 hover:bg-sky-500 disabled:opacity-60"
            >
              {saving ? "Сохраняем…" : confirmLabel}
            </button>
          </div>
        </div>
      </div>

      <div className="max-w-[1526px] mx-auto px-4 py-8 sm:py-12">{children}</div>
    </div>
  );
}
